import { fileUrl } from "@/lib/api";
import { ExternalLink } from "lucide-react";

const AVATAR_FALLBACK = "https://images.unsplash.com/photo-1544785349-c4a5301826fd?crop=entropy&cs=srgb&fm=jpg&q=70&w=400";

export const ArtistCard = ({ artist }) => {
  const photo = artist.photo ? fileUrl(artist.photo) : AVATAR_FALLBACK;
  return (
    <div className="card-dark overflow-hidden text-center transition-colors hover:border-[#D4AF37]/50" data-testid={`artist-card-${artist.id}`}>
      <div className="aspect-square overflow-hidden bg-[#0A0A0C]">
        <img src={photo} alt={artist.name} loading="lazy" className="h-full w-full object-cover"
          onError={(e) => { e.currentTarget.src = AVATAR_FALLBACK; }} />
      </div>
      <div className="p-4">
        <h4 className="font-serif text-lg font-semibold text-white">{artist.name}</h4>
        {artist.role && <p className="mt-0.5 text-xs uppercase tracking-wider text-[#E5C158]">{artist.role}</p>}
        {artist.bio && <p className="mt-2 text-sm text-zinc-400 line-clamp-3">{artist.bio}</p>}
        {artist.social_link && (
          <a href={artist.social_link} target="_blank" rel="noreferrer"
            className="mt-3 inline-flex items-center gap-1 text-sm text-[#E5C158] hover:underline">
            Follow <ExternalLink size={13} />
          </a>
        )}
      </div>
    </div>
  );
};
